var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_258_804)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 20,
    r: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2361 19.2078C21.0478 19.2078 20.0845 20.171 20.0845 21.3594C20.0845 22.5477 21.0478 23.5111 22.2361 23.5111C23.4244 23.5111 24.3878 22.5477 24.3878 21.3594C24.3878 20.171 23.4244 19.2078 22.2361 19.2078Z",
    fill: "#713EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3332 11.3367C18.7767 11.3367 17.3941 12.4792 17.1454 14.0546H14.8974C13.0758 14.0546 11.6699 15.4605 11.6699 17.2821V25.4357C11.6699 27.2573 13.0758 28.6632 14.8974 28.6632H29.3929C31.2144 28.6632 32.6203 27.2573 32.6203 25.4357V17.2964C32.7204 15.4427 31.1919 14.0546 29.4834 14.0546H27.234C26.991 12.5571 25.6964 11.3367 24.0477 11.3367H20.3332ZM18.0457 21.3594C18.0457 19.0453 19.9217 17.1693 22.2358 17.1693C24.5499 17.1693 26.4259 19.0453 26.4259 21.3594C26.4259 23.6735 24.5499 25.5495 22.2358 25.5495C19.9217 25.5495 18.0457 23.6735 18.0457 21.3594ZM29.9365 18.1878C29.9365 18.9383 29.3281 19.5467 28.5775 19.5467C27.827 19.5467 27.2186 18.9383 27.2186 18.1878C27.2186 17.4373 27.827 16.8289 28.5775 16.8289C29.3281 16.8289 29.9365 17.4373 29.9365 18.1878Z",
    fill: "#713EFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_258_804",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_258_804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_258_804",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCam);
export default __webpack_public_path__ + "static/media/cam.dd227c3d8ef60fa854bc2cc90cb415d1.svg";
export { ForwardRef as ReactComponent };